import React from "react";

import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";

import "./NotFound.css";

const NotFound = () => {
  return (
    <div>
      <Helmet>
        <title>Coin Basis: 404 - Not Found</title>
        {/* Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-1T6SHZQ9X8"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-1T6SHZQ9X8');
          `}
        </script>
        <script>
          {`
            (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
              f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-MTZT7D3V');
          `}
        </script>
      </Helmet>
      <Navbar />
      <div className="not-found-container1">
        <h3 style={{ marginTop: "82px" }}>OOPS! PAGE NOT FOUND</h3>
        <div className="not-found-container2">
          <h1 className="not-found-text2">404</h1>
        </div>
        <div className="not-found-container3">
          <h2 className="not-found-text3">
            WE ARE SORRY, BUT THE PAGE YOU REQUESTED WAS NOT FOUND
          </h2>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
